<template>
  <div class="scopeSelector">

    <matchUser label="指定用户：" v-model="accountInfos" text="" @change="updateAccounts" :need-confirm="needConfirm"
      :disable="readOnly" />

    <div class="scopeList" v-for="(tag, index) in userScopeList" :key="index">
      <el-form-item :label="label + (index + 1)">

        <el-tag style="max-width: 220px;" :key="tag" :closable="!readOnly" :disable-transitions="false"
          @close="removeUserScope(index)">
          <div style="display: inline-flex; width: 180px;position: relative;">
            <el-popover placement="top-start" width="800" trigger="click" @show="popShow">
              <div>
                <div v-if="scopeForms[index].posIdStr" >
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">门店</span> <el-input v-model="popPosId"
                      style="width: 180px;margin-left: 20px"><el-button @click="popPosIdSearch" slot="append"
                        icon="el-icon-search"></el-button>
                    </el-input>
                    <span style="color:red;margin-left: 20px;">*仅支持精确查找</span>
                  </div>
                  <div style="height:150px;width: 100%;overflow: auto;margin-top: 10px;" id="door-container">
                    <el-row>
                      <el-col :span="2" v-for="item in Array.from(new Set(scopeForms[index].posIds))" :key="item"
                        :id="'door-' + item">
                        <div :style="targetPosId === item ? { color: '#67c23a' } : {}">{{ item }}</div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-if="scopeForms[index].regions.length>0" style="margin-top: 10px;">
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">区域</span> 
                  </div>
                  <div style="width: 100%;" id="region-container">
                    <el-row>
                      <el-col :span="4" v-for="item in Array.from(new Set(scopeForms[index].regions))" :key="item"
                        :id="'region-' + item">
                        {{ getTargetNameByNo(item, regionOptions, "regionNo", "regionName") }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-if="scopeForms[index].provinces.length>0" style="margin-top: 10px;">
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">省份</span> 
                  </div>
                  <div style="width: 100%;" id="province-container">
                    <el-row>
                      <el-col :span="4" v-for="item in Array.from(new Set(scopeForms[index].provinces))" :key="item"
                        :id="'province-' + item">
                        {{ getTargetNameByNo(item, provinceOptions, "provinceNo", "provinceName") }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-if="scopeForms[index].citys.length>0" style="margin-top: 10px;">
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">城市</span> 
                  </div>
                  <div style="width: 100%;" id="city-container">
                    <el-row>
                      <el-col :span="4" v-for="item in Array.from(new Set(scopeForms[index].citys))" :key="item"
                        :id="'city-' + item">
                        {{ getTargetNameByNo(item, cityOptions, "cityNo", "cityName") }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-if="scopeForms[index].resellers.length>0" style="margin-top: 10px;">
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">客户</span> 
                  </div>
                  <div style="width: 100%;" id="reseller-container">
                    <el-row>
                      <el-col :span="4" v-for="item in Array.from(new Set(scopeForms[index].resellers))" :key="item"
                        :id="'reseller-' + item">
                        {{ getTargetNameByNo(item, resellerOptions, "resellerNo", "resellerName") }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <div v-if="scopeForms[index].roles.length>0" style="margin-top: 10px;">
                  <div style="width: 100%; display: inline-block;"><span
                      style="width: 80px;line-height: 30px;font-weight: bolder; border: 1px solid #67c23a;padding: 0 20px;background-color: #ffe1cc;color: #67c23a;">角色</span> 
                  </div>
                  <div style="width: 100%;" id="role-container">
                    <el-row>
                      <el-col :span="4" v-for="item in Array.from(new Set(scopeForms[index].roles))" :key="item"
                        :id="'role-' + item">
                        {{ getTargetNameByNo(item, roleOptions, "roleCode", "roleName") }}
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </div>
              <div
                style="max-width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;cursor: zoom-in;"
                slot="reference">{{ tag }}</div>
            </el-popover>
          </div>
        </el-tag>
        <el-button style="margin-left: 10px" type="success" size="mini" icon="el-icon-edit"
          @click="openEditScope(index)" v-if="!readOnly">编辑</el-button>
        <el-button type="info" size="mini" icon="el-icon-delete" @click="removeUserScope(index)"
          v-if="!readOnly">删除</el-button>
      </el-form-item>
    </div>

    <el-card class="box-card" v-if="!readOnly">
      <div slot="header">
        <span>新增范围</span>
      </div>
      <!-- <el-form-item label="用户体系">
        <el-select v-model="scopeForm.domains" multiple placeholder="请选择用户体系" @visible-change="(visible)=>{resetFilters(visible, scopeForm)}" class="filterSelect">
          <el-option
            v-for="item in domainOptions"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="区域">
        <el-select v-model="scopeForm.regions" multiple placeholder="请选择区域"
          @visible-change="(visible) => { resetFilters(visible, scopeForm) }" class="filterSelect">
          <el-option v-for="item in regionOptions" :key="item.regionNo" :label="item.regionName" :value="item.regionNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省份">
        <el-select v-model="scopeForm.provinces" multiple placeholder="请选择省份"
          @visible-change="(visible) => { resetFilters(visible, scopeForm) }" class="filterSelect" :key="'province'">
          <el-option v-for="item in provinceOptions" :key="item.provinceNo" :label="item.provinceName"
            :value="item.provinceNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="scopeForm.citys" multiple placeholder="请选择城市"
          @visible-change="(visible) => { resetFilters(visible, scopeForm) }" class="filterSelect">
          <el-option v-for="item in cityOptions" :key="item.cityNo" :label="item.cityName" :value="item.cityNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客户">
        <el-select v-model="scopeForm.resellers" multiple placeholder="请选择"
          @visible-change="(visible) => { resetFilters(visible, scopeForm) }" class="filterSelect">
          <el-option v-for="item in resellerOptions" :key="item.resellerNo" :label="item.resellerName"
            :value="item.resellerNo">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="scopeForm.roles" multiple placeholder="请选择"
          @visible-change="(visible) => { resetFilters(visible, scopeForm) }" class="filterSelect">
          <el-option v-for="item in roleOptions" :key="item.roleCode" :label="item.roleName" :value="item.roleCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="门店">
        <!-- <el-input v-model="form.posIdStr" :placeholder="$t('filters.choosePOSID')"
                            class="filterSelect" style="width: 45%;display: inline-flex;">
                          </el-input> -->
        <!-- <el-form-item :label="$t('filters.doorName')"> -->
        <span @click="onChooseDoor(scopeForm)" style="width: 70%;display: inline-flex;">
          <el-input v-model="scopeForm.posIdStr" :placeholder="$t('filters.choosePOSID')" class="filterSelect"
            style="width: 100%;display: inline-flex;">
          </el-input>
        </span>
        <el-upload v-show="false" :action="'#'" :on-success="() => { fileChange(editScopeForm); }"
          :before-upload="beforeUpload">
          <el-button ref="uploadBtn" v-show="false">点击上传</el-button>
        </el-upload>
        <div style="display: inline-flex;margin-left: 20px;" @click="upload">
          <el-button type="primary">导入</el-button>
        </div>
        <div style="display: inline-flex;margin-left: 20px;" @click="resetDoors(scopeForm)">
          <el-button type="primary">重置</el-button>
        </div>
        <el-button type="text" style="margin-left: 20px" @click="downloadTemplate"><i
            class="el-icon-info"></i>模板下载</el-button>
      </el-form-item>
      <!--
      <el-form-item label="Cluster Name">
        <el-select v-model="ruleForm.clusterNames" multiple placeholder="请选择" @visible-change="resetFilters" class="filterSelect">
          <el-option
            v-for="item in clusterNameOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Concept">
        <el-select v-model="ruleForm.concepts" multiple placeholder="请选择" @visible-change="resetFilters" class="filterSelect">
          <el-option
            v-for="item in conceptOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="City Tier">
        <el-select v-model="ruleForm.cityTiers" multiple placeholder="请选择" @visible-change="resetFilters" class="filterSelect">
          <el-option
            v-for="item in cityTierOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Tz Group">
        <el-select v-model="ruleForm.tzGroups" multiple placeholder="请选择" @visible-change="resetFilters" class="filterSelect">
          <el-option
            v-for="item in tzGroupOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Format">
        <el-select v-model="ruleForm.formats" multiple placeholder="请选择" @visible-change="resetFilters" class="filterSelect">
          <el-option
            v-for="item in formatOptions"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      -->
      <!--<matchUser
        v-model="accountInfos"
        text=""
      />-->
      <div>
        <slot name="extend"></slot>
      </div>
      <div style="text-align: center; margin-top: 10px;" v-if="!readOnly">
        <el-button type="success" size="small" @click="addUserScope">添加</el-button>
        <el-button type="info" size="small" @click="resetRangeFilter">重置</el-button>
      </div>
    </el-card>

    <ul class="box-tip" style="margin-top: 10px" v-if="!readOnly">
      <li class="tipText">* 无适用范围及指定用户时，默认对所有用户开放</li>
      <li class="tipText">* 每添加一次增加一个适用范围,所有的{{ label }}取并集</li>
      <li class="tipText">* 内容过多时，点击适用范围可查看详细内容</li>
    </ul>

    <div class="box-tip" style="text-align: left;margin-top: 10px;" v-if="showExport">
      <el-button size="small" @click="exportScopeAccount">导出关联用户</el-button>
    </div>
    <div class="box-tip" style="text-align: left;margin-top: 10px;">
      <slot name="export">

      </slot>
    </div>

    <el-dialog title="编辑适用范围" :visible.sync="editDialogVisible" width="80%">
      <div class="editSelector">
        <el-form :model="editScopeForm" label-width="120px">
          <!-- <el-form-item label="用户体系">
            <el-select v-model="editScopeForm.domains" multiple placeholder="请选择用户体系" @visible-change="(visible)=>{resetFilters(visible, editScopeForm)}" class="filterSelect">
              <el-option
                v-for="item in domainOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="区域">
            <el-select v-model="editScopeForm.regions" multiple placeholder="请选择区域"
              @visible-change="(visible) => { resetFilters(visible, editScopeForm) }" class="filterSelect">
              <el-option v-for="item in regionOptions" :key="item.regionNo" :label="item.regionName"
                :value="item.regionNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="省份">
            <el-select v-model="editScopeForm.provinces" multiple placeholder="请选择省份"
              @visible-change="(visible) => { resetFilters(visible, editScopeForm) }" class="filterSelect"
              :key="'province'">
              <el-option v-for="item in provinceOptions" :key="item.provinceNo" :label="item.provinceName"
                :value="item.provinceNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市">
            <el-select v-model="editScopeForm.citys" multiple placeholder="请选择城市"
              @visible-change="(visible) => { resetFilters(visible, editScopeForm) }" class="filterSelect">
              <el-option v-for="item in cityOptions" :key="item.cityNo" :label="item.cityName" :value="item.cityNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户">
            <el-select v-model="editScopeForm.resellers" multiple placeholder="请选择"
              @visible-change="(visible) => { resetFilters(visible, editScopeForm) }" class="filterSelect">
              <el-option v-for="item in resellerOptions" :key="item.resellerNo" :label="item.resellerName"
                :value="item.resellerNo">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="editScopeForm.roles" multiple placeholder="请选择"
              @visible-change="(visible) => { resetFilters(visible, editScopeForm) }" class="filterSelect">
              <el-option v-for="item in roleOptions" :key="item.roleCode" :label="item.roleName" :value="item.roleCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="门店">
            <!-- <el-input v-model="form.posIdStr" :placeholder="$t('filters.choosePOSID')"
                            class="filterSelect" style="width: 45%;display: inline-flex;">
                          </el-input> -->
            <!-- <el-form-item :label="$t('filters.doorName')"> -->
            <span @click="onChooseDoor(editScopeForm)" style="width: 60%;display: inline-flex;">
              <el-input v-model="editScopeForm.posIdStr" :placeholder="$t('filters.choosePOSID')" class="filterSelect"
                style="width: 100%;display: inline-flex;">
              </el-input>
            </span>
            <el-upload v-show="false" :action="'#'" :on-success="() => { fileChange(editScopeForm); }"
              :before-upload="beforeUpload">
              <el-button ref="uploadBtn" v-show="false">点击上传</el-button>
            </el-upload>
            <div style="display: inline-flex;margin-left: 20px;" @click="upload">
              <el-button type="primary">导入</el-button>
            </div>
            <div style="display: inline-flex;margin-left: 20px;" @click="resetDoors(editScopeForm)">
              <el-button type="primary">重置</el-button>
            </div>
            <el-button type="text" style="margin-left: 20px" @click="downloadTemplate"><i
                class="el-icon-info"></i>模板下载</el-button>
          </el-form-item>
        </el-form>
        <div style="text-align: center; margin-top: 10px">
          <el-button type="success" size="small" @click="editScope">保存修改</el-button>
          <el-button type="info" size="small" @click="cancelEditScope">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <pickDoor v-model="target.posIdStr" ref='PickDoor' />
  </div>
</template>

<script>
import _ from "lodash";
import matchUser from "@/components/matchUser";
import pickDoor from "@/components/pickDoor";

export default {
  name: "scopeSelector",
  components: {
    matchUser,
    pickDoor
  },

  props: {
    value: Object,
    needConfirm: false,
    showExport: {
      type: Boolean,
      default: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '适用范围'
    }
  },
  data() {
    return {
      editDialogVisible: false,
      userScopeList: [],  //适用范围
      posIdStr: '',
      target: {},
      scopeForm: {
        // accounts: [], // 指定用户
        domains: [],
        regions: [], // 区域
        provinces: [], // 省份
        citys: [], // 城市
        resellers: [], // 客户
        roles: [], // 角色
        posIds: [],
        posIdStr: ''
      },
      editScopeForm: {},
      editScopeIndex: '',
      initScopeForm: {
        // accounts: [], // 指定用户
        domains: [],
        regions: [], // 区域
        provinces: [], // 省份
        citys: [], // 城市
        resellers: [], // 客户
        roles: [], // 角色
        posIds: [],
        posIdStr: ''
      },
      // 编辑多个范围的各个scopeForm
      scopeForms: [
      ],
      domainOptions: [
      ],
      regionOptions: [
      ],
      provinceOptions: [
      ],
      cityOptions: [
      ],
      clusterNameOptions: [
      ],
      conceptOptions: [
      ],
      cityTierOptions: [
      ],
      tzGroupOptions: [
      ],
      formatOptions: [
      ],
      resellerOptions: [
      ],
      roleOptions: [
      ],
      accountInfos: [],
      popPosId: "",
      targetPosId: "",
    }
  },
  mounted() {
    this.getRangeList(this.initScopeForm);
  },
  methods: {
    getRangeList: async function (scopeForm, clear) {
      let filterParams = {
        'domains': scopeForm.domains,
        'cityNos': scopeForm.citys,
        'clusterGroups': scopeForm.cityTiers,
        'clusterNames': scopeForm.clusterNames,
        'concepts': scopeForm.concepts,
        'resellerNos': scopeForm.resellers,
        'roles': scopeForm.roles,
        'formats': scopeForm.formats,
        'provinceNos': scopeForm.provinces,
        'regionNos': scopeForm.regions,
        'tzGroups': scopeForm.tzGroups
      }
      let submitParams = filterParams
      if (clear) {
        submitParams = {}
      }
      let res = await window.instance.post(window.pubServer + 'external/searchQuery', submitParams)
      res = res.data.data.searchQuery
      this.domainOptions = res.domains
      this.regionOptions = res.regionNos
      this.provinceOptions = res.provinceNos
      this.cityOptions = res.cityNos
      this.cityTierOptions = res.clusterGroups
      this.clusterNameOptions = res.clusterNames
      this.conceptOptions = res.concepts
      this.formatOptions = res.formats
      this.resellerOptions = res.resellerNos
      this.roleOptions = res.roles
      this.tzGroupOptions = res.tzGroups
    },
    exportScopeAccount: function () {
      this.$tool.exportFile({ method: "post", url: window.pubServer + "export/exportScopeAccount", data: this.computeData() });
    },
    // 筛选条件联动
    resetFilters: function (visible, scopeForm) {
      console.log('visible', visible)
      console.log('scopeForm', scopeForm)
      if (!visible) {
        this.getRangeList(scopeForm)
      }
    },
    onChooseDoor: function (target) {
      this.target = target
      this.$refs.PickDoor.openDialog();
    },
    // 重置范围筛选条件
    resetRangeFilter: function () {
      this.scopeForm = _.cloneDeep(this.initScopeForm)
      this.getRangeList(this.scopeForm)
    },


    // 打开编辑范围弹窗
    openEditScope(index) {
      this.editScopeIndex = index
      this.editScopeForm = _.cloneDeep(this.scopeForms[index])
      this.getRangeList(this.editScopeForm)
      this.editDialogVisible = true
    },

    // 编辑指定范围
    editScope() {
      let editedScope = _.cloneDeep(this.editScopeForm);
      let scopeAll = this.confirmScope(editedScope);
      if (scopeAll.length < 1) {
        this.$message({ message: "请选择有效用户范围", type: "warning" });
        return;
      }
      if (editedScope.posIdStr) {
        editedScope.posIds = editedScope.posIdStr ? editedScope.posIdStr.split(",").filter(i => i != "") : []
      }
      this.userScopeList[this.editScopeIndex] = scopeAll
      this.scopeForms[this.editScopeIndex] = editedScope
      // 不重新赋值无法触发vue的ui更新
      console.log(editedScope);
      this.userScopeList = _.cloneDeep(this.userScopeList)
      this.scopeForms = _.cloneDeep(this.scopeForms)
      this.$emit('input', this.computeData())
      this.editDialogVisible = false
      this.getRangeList(this.initScopeForm)
    },

    // 取消编辑指定范围
    cancelEditScope() {
      this.editDialogVisible = false
      this.getRangeList(this.initScopeForm)
    },

    // 添加用户范围
    addUserScope() {
      let scopeAll = this.confirmScope(this.scopeForm);
      if (this.scopeForm.posIdStr) {
        this.scopeForm.posIds = this.scopeForm.posIdStr ? this.scopeForm.posIdStr.split(",").filter(i => i != "") : []
      }
      if (scopeAll.length < 1) {
        this.$message({ message: "请选择有效用户范围", type: "warning" });
        return;
      }
      this.userScopeList.push(scopeAll);
      console.log(this.scopeForm);
      this.scopeForms.push(_.cloneDeep(this.scopeForm))
      this.scopeForm = _.cloneDeep(this.initScopeForm);
      this.$emit('input', this.computeData())
      this.getRangeList(this.initScopeForm)
    },

    // 确定选择的范围
    confirmScope(scope) {
      console.log(scope)
      let domainScope = scope.domains;

      if (scope.posIds.length > 0) {
        scope.posIdStr = scope.posIds.join(",")
      }

      let posIds = scope.posIdStr;

      let regionScope = this.getNameByNo(scope.regions, this.regionOptions, "regionNo", "regionName")

      let provinceScope = this.getNameByNo(scope.provinces, this.provinceOptions, "provinceNo", "provinceName")

      let cityScope = this.getNameByNo(scope.citys, this.cityOptions, "cityNo", "cityName")

      let resellerScope = this.getNameByNo(scope.resellers, this.resellerOptions, "resellerNo", "resellerName")

      let roleScope = this.getNameByNo(scope.roles, this.roleOptions, "roleCode", "roleName")

      let scopeAll = '';

      if (posIds) {
        scopeAll += posIds + ";";
      }
      if (domainScope && domainScope.length > 0) scopeAll += domainScope + ';';
      if (regionScope.length > 0) scopeAll += regionScope + ';';
      if (provinceScope.length > 0) scopeAll += provinceScope + ';';
      if (cityScope.length > 0) scopeAll += cityScope + ';';
      if (resellerScope.length > 0) scopeAll += resellerScope + ';';
      if (roleScope.length > 0) scopeAll += roleScope + ';';
      /*scope.accounts = this.accountInfos.filter(i=>i.valid).map((i) => i.account);
      if(scope.accounts.length>0)scopeAll += '指定用户;';*/
      console.log('scopeAll', scopeAll);
      return scopeAll;
    },

    // 移除用户范围
    removeUserScope: function (index) {
      this.userScopeList.splice(index, 1);
      this.scopeForms.splice(index, 1);
      this.$emit('input', this.computeData())
    },

    // selectedIds是选中项的数组
    // data是select里所有的选项
    // key属性名
    getNameByNo(selectedIds, data, key, labelName) {
      let result = [];
      _.each(data, (option) => {
        if (_.indexOf(selectedIds, option[key]) !== -1) {
          result.push(option[labelName])
        }
      });
      return result
    },

    getTargetNameByNo(selectedId, data, key, labelName) {
      let result ="";
      _.each(data, (option) => {
        if (_.indexOf([selectedId], option[key]) !== -1) {
          result = option[labelName]
        }
      });
      return result;
    },

    // 计算得到的最终需要的格式的数据,emit给父组件
    computeData() {
      let scopes = []
      _.each(this.scopeForms, (scope) => {
        let domains = scope.domains;
        let regionNos = scope.regions;
        let provinceNos = scope.provinces;
        let cityNos = scope.citys;
        let resellerNos = scope.resellers;
        let roleCodes = scope.roles;
        let posIds = scope.posIds
        scopes.push({
          domains,
          regionNos,
          provinceNos,
          cityNos,
          resellerNos,
          roleCodes,
          posIds,
        })
      })
      console.log('this.accountInfos', this.accountInfos)
      let multipleAccountVo = {
        accountList: this.accountInfos,
        accountNos: (this.accountInfos && this.accountInfos.length) ? this.accountInfos.filter(i => i.valid).map((i) => i.account) : [],
        scopes
      }
      return multipleAccountVo
    },

    updateAccounts(accounts) {
      this.accountInfos = accounts
      console.log('上传用户文件更新', accounts)
      this.$emit('input', this.computeData())
    },

    // 获取到的范围数据(来自接口),变成选择器需要的格式
    getDataFromOriginData(newVal) {
      let _this = this;
      setTimeout(function () {
        if (newVal.accountList) {
          _this.getAccountData(newVal.accountList)
        }
        _this.getScopeData(newVal.scopes)
      }, 800)
    },

    // 获取account数据
    getAccountData(accounts) {
      this.accountInfos = accounts
    },

    // 获取scopes数据
    getScopeData(scopes) {
      // userScopeList;
      // scopeForms;
      let newUserScopeList = []
      let newScopeForms = []

      _.each(scopes, (scope) => {
        // console.log('scope', scope);
        let scopeForm = {
          domains: scope.domains,
          regions: scope.regionNos,
          provinces: scope.provinceNos,
          citys: scope.cityNos,
          resellers: scope.resellerNos,
          roles: scope.roleCodes,
          posIds: scope.posIds
        }
        scope.posIdStr = ''
        if (scope.posIds.length > 0) {
          scope.posIdStr = scope.posIds.join(',')
        }
        newScopeForms.push(scopeForm)
        newUserScopeList.push(this.confirmScope(scopeForm))
      })
      this.userScopeList = newUserScopeList
      this.scopeForms = newScopeForms
    },
    upload() {
      this.$refs.uploadBtn.$el.click();
    },
    fileChange(item) {
      this.target = item;
      console.log(1);
    },
    beforeUpload(file) {
      if (this.editDialogVisible) {
        this.target = this.editScopeForm
      } else {
        this.target = this.scopeForm
      }
      let that = this;
      const isSupport =
        file.name.toLowerCase().endsWith(".xls") ||
        file.name.toLowerCase().endsWith(".xlsx");

      if (!isSupport) {
        this.$message.error("仅支持excel文件");
        return false;
      }

      let formData = new FormData();
      formData.append("file", file);
      window.instance
        .post(window.surveyUrl + "doors/import", formData)
        .then(res => {
          let { data } = res.data;

          that.target.posIdStr = data.success.join(",");
          that.target.posIds = data.success;
          console.log(JSON.stringify(that.target));
          if (data.error.length==0) {
            this.$message.success("导入成功！");
          } else {
            this.$message({
          duration: 0,
          showClose: true,
          message: "门店POSID: " + data.error.join(",") +' 是无效的',
          type: 'warning'
        });
          }
        });

      return false;
    },
    downloadTemplate: async function () {
      let response = await window.instance({
        method: "get",
        responseType: "blob",
        url: window.surveyUrl + "doors/template"
      });

      let fileName = decodeURI(
        response.headers["content-disposition"].split("''")[1]
      );
      let res = response.data;
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(a.href);
      a.remove();
    },
    resetDoors: function (target) {
      target.posIds = []
      target.posIdStr = ''
    },
    popShow: function () {
      this.popPosId = ""
      this.targetPosId = ""
    },
 
    popPosIdSearch: function (e) {
      this.targetPosId = this.popPosId
      let em = document.getElementById("door-container")
      let target = em.querySelector("#door-" + this.targetPosId)
      em.scrollTo({
        top:target.offsetTop,
        behavior:"smooth"
      }) 
      e.target.blur()
    }
  },
  watch: {
    'value': {
      handler(newVal, oldVal) {
        // console.log('oldVal', oldVal)
        // console.log('newVal', newVal)
        // 没有oldVal,或者oldVal={}, 也就是第一次组件加载数据的时候,才调用,组件内部发生变化不调用这个方法,只有外部传入的值发生变化才调用
        // if (!oldVal || Object.keys(oldVal).length === 0) {
        this.getDataFromOriginData(newVal)
        // }
      },
      deep: true,
      immediate: true
    }
  },

  computed: {
  }
}
</script>

<style lang="sass" scoped>

  .scopeSelector
    .tipText
      font-size: 14px
      color: red
    .scopeList
      margin-bottom: 18px
      .editSelector
        padding: 0 20px 0 20px
        background: #fff
      .scopeItem
        margin: 10px 20px
        span.title
          font-size: 14px
          margin-right: 12px
          color: #606266
    .filterSelect
      width: 100%
</style>



// WEBPACK FOOTER //
// src/openSurvey/components/scopeSelector.vue